export const INICIAR_VENTANA_TRAZADORA = 'INICIAR_VENTANA_TRAZADORA';
export const SET_VISIBLE = 'SET_VISIBLE';
export const SET_ALERT = 'SET_ALERT';
